module.exports = __webpack_public_path__ + "img/246.a49378db.png";